import { useTranslation } from 'react-i18next'
import { GOAL_FIELDS } from './goalFields'

// VH-231: what finalizing does to the active goal — current vs new, with the
// difference per field. Finalizing never changes the daily goal unseen.

const fmt = (v) => (v === null || v === undefined ? '–' : Math.round(Number(v) * 10) / 10)

export function GoalChangePreview({ effect }) {
  const { t } = useTranslation()
  if (!effect || effect.available === false) {
    return (
      <div className="border border-dashed border-gray-300 rounded-md p-3" data-testid="goal-change-preview">
        <p className="text-sm font-medium text-gray-900">{t('healthCycle.finalize.goal.title')}</p>
        <p className="text-xs text-gray-500 mt-1">{t('healthCycle.finalize.goal.notAvailable', { feature: effect?.feature || 'VH-231' })}</p>
      </div>
    )
  }
  const { current, new: next, diff = {}, applies, reason } = effect
  const fields = GOAL_FIELDS.filter((f) => next && (next[f.key] != null || current?.[f.key] != null))
  return (
    <div className="border border-gray-200 rounded-md p-3" data-testid="goal-change-preview">
      <p className="text-sm font-medium text-gray-900">{t('healthCycle.finalize.goal.title')}</p>
      {!applies && (
        <p className="text-xs text-gray-600 mt-1" data-testid="goal-change-reason">
          {t(`healthCycle.finalize.goal.reasons.${reason || 'no_nutrition_targets'}`)}
        </p>
      )}
      {next && (
        <table className="mt-2 w-full text-xs">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="font-normal py-1">{t('healthCycle.finalize.goal.field')}</th>
              {current && <th className="font-normal py-1">{t('healthCycle.finalize.goal.current')}</th>}
              <th className="font-normal py-1">{t('healthCycle.finalize.goal.new')}</th>
              {current && <th className="font-normal py-1">{t('healthCycle.finalize.goal.difference')}</th>}
            </tr>
          </thead>
          <tbody>
            {fields.map((f) => {
              const d = diff[f.key]
              return (
                <tr key={f.key} className="border-t border-gray-100">
                  <td className="py-1 text-gray-700">{t(`goalFields.${f.key}`)}</td>
                  {current && <td className="py-1 text-gray-600">{fmt(current[f.key])} {f.unit}</td>}
                  <td className="py-1 font-medium text-gray-900">{fmt(next[f.key])} {f.unit}</td>
                  {current && (
                    <td className="py-1 text-gray-600">{d === null || d === undefined ? '–' : `${d > 0 ? '+' : ''}${fmt(d)}`}</td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
      {applies && effect.target_weight_kept && (
        <p className="text-xs text-gray-500 mt-2">{t('healthCycle.finalize.goal.targetWeightKept')}</p>
      )}
      {applies && !current && <p className="text-xs text-gray-500 mt-2">{t('healthCycle.finalize.goal.noCurrent')}</p>}
    </div>
  )
}

export default GoalChangePreview
